<template>
	<div class="row">
		<div class="col-md-12">
			<h3 v-html="formTitle" class="text-center"></h3>
			<div class="form-group">
				<label>Adresse Email du réalisateur à associer (le compte doit être créé au préalable): </label>
				<bsInput required type="text" v-model.lazy="email"></bsInput>
				<div style="color:red;" v-if="requiredEmail">
						Le nom doit être défini.
				</div>
                		<div class="col-md-12 text-right">
			<button class="btn btn-info btn-sm" type="button" @click="save">Sauvegarder</button>
		</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { input as BsInput, select as VSelect, option as VOption }  from 'vue-strap'

    export default {
        components: {
            BsInput,
            VSelect,
            VOption
        },
        computed: {
            currentPerson: function() {
                return this.$store.state.admin.currentPerson;
            },
            formMode: function() {
				return this.$route.meta.mode;
            },
            formTitle() {
                return "Lier un réalisateur";
            },
            email: {
                get() {
                    return this.currentPerson.email;
                },
                set(value) {
                    this.$store.commit('CURRENT_PERSON_UPDATED', {key: 'email', data: value});
                }
            },
        },
        methods: {
            save()  {
                if (this.email != "")    {
                    let textPatch = 'créé';
                    let successCallback = (id) => {
                        this.$router.push({ name: 'RealList', params: { themeId: this.$route.params.themeId }});
                        this.$store.commit('ALERT_DATA_UPDATED', {
                            text: 'Le réalisateur est lié à la formation.',
                            type: 'success'
                        });
                    };

                    this.$store.dispatch('linkReal', {
                        themeId: this.$route.params.themeId,
                        email: this.email,
                        callbacks: { success: successCallback }
                    });
                }
                else    {
                    this.requiredEmail = true;
                }
            }
        },
        data: function()  {
            return {
                requiredEmail: false
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux réalisateurs',
                pathData: {
                    name: "RealList",
                    params: {
                        themeId: this.$route.params.themeId
                    }
                }
            });
        }
    };
</script>
